const isSupported = () => window && window.addEventListener;

export const addEventListener = (
  eventName: string,
  handler: (event: any) => void,
) => {
  if (isSupported()) {
    window.addEventListener(eventName, handler);
  }
};

export const removeEventListener = (
  eventName: string,
  handler: (event: any) => void,
) => {
  if (isSupported()) {
    window.removeEventListener(eventName, handler);
  }
};
